<template>
    <div class="xczx_result_ending_box">
      <div class="content">
        <div class="title">感谢您的参与!</div>
        <div class="product">云南特色产品公益集市</div>
        <div class="qcard">
            <div>
              <div @click="qcord"><img src="./img/dh.png" alt=""></div>
              <div>请直接点击上方二维码<br />参与消费帮扶</div>
            </div>
            <div>
              <div @click="previewImg"><img src="./img/miniProgram.jpg" alt=""></div>
              <div>请用微信"扫一扫"上方二维码<br />参与消费帮扶</div>
            </div>
        </div>
      </div>
        <van-overlay :show="showAlert" @click="showAlert = false">
            <div class="wrapper">
              <img src="./img/miniProgram.jpg" style="width: 300px; height: 300px;" alt="">
            </div>
        </van-overlay>
    </div>
</template>

  <script>
    /* eslint-disable */
    export default {
      name: 'xczx',
      data () {
        return {
            showAlert: false,
        }
      },
      methods:{
        qcord() {
            window.location.href = 'https://shopping.ceair.com/static/actTmpl/activityTemplate-PC.html?pageCode=MALL_M55215_2020091801092815&iad=app_43_258_a7_7758'
        },
        // 预览图片
        previewImg() {
            this.showAlert = true 
        }
      }
    }
  </script>
<style scoped>
  .xczx_result_ending_box {
    text-align: center;
    height: 100vh;
    padding-top: 40%;
    overflow: hidden;
    background: url('./img/bg.png');
    background-repeat: no-repeat;
    background-size: cover;
  }

  .content {
    padding: 30px 20px;
    background-color: #fff8e6;
    font-family: "思源黑体";
  }

  .title {
    font-size: 40px;
    color: #cc0000;
    font-weight: 700;
  }

  .product {
    font-size: 22px;
    color: #cc0000;
    font-weight: 700;
    padding: 30px;
  }

  .qcard {
    display: flex;
    padding: 40px 30px 20px 30px;
    justify-content: center;
    text-align: center;
    font-size: 11px;
  }

  .qcard  img {
    width: 100px;
    height: 100px;
    margin-bottom: 15px;
  }

  .qcard div {
    flex: 1;
  }
  .qcard div:nth-child(1) {
    margin-right: 5px;
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// result.vue?3403f0ed